var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"white--text certificate-btn",attrs:{"color":"#F39200","disabled":_vm.disabled,"dark":_vm.disabled},on:{"click":() => _vm.$emit('onClick')}},[_c('img',{staticClass:"mr-1",attrs:{"src":require("@assets/exam/tests.webp"),"alt":"downloads all tests"}}),_vm._v(" Scarica tutti i test ")])
}
var staticRenderFns = []

export { render, staticRenderFns }